<template>
  <div class="statistics">
    <div class="member-statistics margin-bottom statistics-some padding">
      <h3 class="padding-bottom">会员数据筛选分析</h3>
      <el-row :gutter="20">
        <el-col :span="8" class="search-some">
          <span>会员等级：</span>
          <el-select v-model="level" placeholder="请选择">
            <el-option
              v-for="item in levelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8" class="search-some">
          <span>会员类型：</span>
          <el-select v-model="memberType" placeholder="请选择">
            <el-option
              v-for="item in memberTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8" class="search-some">
          <span>单位性质：</span>
          <el-select v-model="nature" placeholder="请选择">
            <el-option
              v-for="item in natureList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8" class="search-some">
          <span>注册地区：</span>
          <el-select v-model="register" placeholder="请选择">
            <el-option
              v-for="item in addressList"
              :key="item.label"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8" class="search-some">
          <span>经营地区：</span>
          <el-select v-model="management" placeholder="请选择">
            <el-option
              v-for="item in addressList"
              :key="item.label"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8" class="search-some">
          <span>缴费状态：</span>
          <el-select v-model="fee" placeholder="请选择">
            <el-option
              v-for="item in feeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12" class="search-some">
          <span>证书有效时间：</span>
          <el-date-picker
            v-model="endTime"
            class="flex-sub"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="flex align-center justify-end padding-bottom-sm">
            <el-button
              type="primary"
              class="margin-left font-size"
              @click="getbrokenLineChart"
              >搜索</el-button
            >
            <el-button
              type="primary"
              class="margin-left font-size"
              @click="reset"
              >重置</el-button
            >
          </div>
        </el-col>
      </el-row>

      <div class="padding-tb">
          <div class="tips">增长数量：本月度新注册且审批通过、提交续费申请后审批通过的会员合计数。<br/>
              临期数量：本月度将要到期且未提交续费申请的用户数，续费申请后会自动转换为“增长数量”。<br/>
              整体数量：全部已提交入会申请、审核通过、已过有效期且未续费的会员总数。<br/>
              过期会员：全部到期后未续费的会员总数。</div>
        <bp-statistics-modular
          :title="'会员数据筛选统计'"
          :id="'member'"
          :month="month"
          :increase="increaseData"
          :reduce="reduceData"
          :total="totalData"
          :total2="totalData2"
        />
      </div>
    </div>
    <div class="flex flex-wrap margin-bottom statistics-some">
      <div class="w-all padding">
        <span>缴费状态：</span>
        <el-select v-model="fee2" placeholder="请选择">
          <el-option
            v-for="item in feeList2"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <pie-statistics-modular
        :title="'会员等级'"
        :id="'level'"
        :data="levelData"
      />
      <pie-statistics-modular
        :title="'会员分类'"
        :id="'type'"
        :data="typeData"
      />
      <pie-statistics-modular
        :title="'单位性质'"
        :id="'nature'"
        :data="natureData"
      />
      <pie-statistics-modular
        :title="'注册地区'"
        :id="'register'"
        :data="registerData"
      />
      <pie-statistics-modular
        :title="'经营地区'"
        :id="'manage'"
        :data="manageData"
      />
    </div>
    <div class="flex flex-wrap margin-bottom statistics-some">
      <pie-statistics-modular :title="'缴费统计'" :id="'fee'" :data="feeData" />
      <pie-statistics-modular
        :title="'预备会员'"
        :id="'process'"
        :data="processData"
      />
    </div>
    <div class="flex flex-wrap margin-bottom statistics-some">
      <barStatisticsModular
        :title="'供给侧服务类别'"
        :id="'supply'"
        :data="supplyData"
        :list="supplyList"
      />
      <barStatisticsModular
        :title="'需求侧服务类别'"
        :id="'demand'"
        :data="demandData"
        :list="demandList"
      />
    </div>
  </div>
</template>

<script>
import PieStatisticsModular from '@/components/pie-statistics-modular'
import BarStatisticsModular from '@/components/bar-statistics-modular'
import BpStatisticsModular from '../../components/bp-statistics-modular.vue'
import {
  address,
  level,
  memberType,
  nature,
  feeList,
  feeList2,
  zhDate
} from '@/utils/utils'
import { pieChart, columnarChart, brokenLineChart } from '@/api/admin'
export default {
  name: "statistics",
  data () {
    return {
      levelData: [],
      typeData: [],
      natureData: [],
      registerData: [],
      manageData: [],
      feeData: [],
      processData: [],



      supplyList: [],
      supplyData: [],
      demandData: [],
      demandList: [],
      levelList: level,
      feeList: feeList,
      feeList2: feeList2,
      fee2: 0,
      memberTypeList: memberType,
      natureList: nature,
      addressList: address,
      level: '',
      memberType: '',
      nature: '',
      register: '',
      management: '',
      fee: '',
      endTime: null,

      month: [],
      increaseData: [],

      reduceData: [],

      totalData: [],
      totalData2: [],


    }
  },
  created () {
    this.$emit("setIndex", this.$route.path, "会员统计  / ", false, 'icon-tongji');
    this.getStatistice()
    this.getbrokenLineChart()
  },
  components: {
    PieStatisticsModular,
    BarStatisticsModular,
    BpStatisticsModular
  },
  methods: {

    reset () {
      this.level = ''
      this.memberType = ''
      this.nature = ''
      this.register = ''
      this.management = ''
      this.endTime = null
      this.getbrokenLineChart()
    },
    async getStatistice () {
      let _data = await pieChart(this.fee2)
      this.levelData = _data.data.member_level
      this.typeData = _data.data.member_give
      this.natureData = _data.data.company_type
      this.registerData = _data.data.region_register
      this.manageData = _data.data.management
      this.feeData = _data.data.fee
      this.processData = _data.data.process

      let _bar = await columnarChart(this.fee2)
      this.supplyList = _bar.data.gong[0]
      this.supplyData = _bar.data.gong[1]
      this.demandList = _bar.data.xu[0]
      this.demandData = _bar.data.xu[1]


    },
    async getbrokenLineChart () {
      let _data = await brokenLineChart(
        this.level,
        this.memberType,
        this.nature,
        this.register,
        this.management,
        this.fee,
        this.endTime && this.endTime.length > 0 ? zhDate(new Date(this.endTime[0])) : '',
        this.endTime && this.endTime.length > 0 ? zhDate(new Date(this.endTime[1])) : '')
      this.month = _data.data[0]
      this.increaseData = _data.data[1]
      this.reduceData = _data.data[2]
      this.totalData = _data.data[3]
      this.totalData2 = _data.data[4]

    }
  },
  filters: {},
  watch: {
    fee2 () {
      this.getStatistice()
    }
  },
}
</script>

<style scoped lang="scss">
.statistics {
    .tips{
        font-size: 11px;
        line-height: 16px;
        color: #666666;
        margin-bottom: 12px;
    }
  .statistics-some {
    background: #fff;
    border-radius: 10px;
    .search-some {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        display: block;
        width: 100px;
      }

      .el-input {
        flex: 1;
      }

      .el-select {
        flex: 1;
      }
    }
  }
}
</style>
